import { ApiService }          from '../../app-lite/api/api.service';
import { FileUploadOptionsModel } from '../../app-lite/core/directives/file-upload/models/file-upload.options';
import { SessionService }      from '../../app-lite/sessions/session.service';

interface ManageAdvertisementScope extends ng.IScope {
  AdminDashboard       : any;
  display_advertisement: boolean;
  form                 : ng.IFormController;
  options              : FileUploadOptionsModel;
  preview              : string;
  save                 : ( form : ng.IFormController ) => void;
}

export function ManageAdvertisementCtrl (
  $scope          : ManageAdvertisementScope,
  $translate      : ng.translate.ITranslateService,
  AdminDashboard  : any,
  advertisementUrl: string,
  messages        : any,
  sessionObjAPI   : SessionService,
  workshopAPI     : ApiService
) {
  $scope.AdminDashboard = new AdminDashboard();

  $scope.display_advertisement = $scope.AdminDashboard.displayAdvertisement();
  $scope.preview               = advertisementUrl + '?decache=' + Math.random();

  $scope.options = {
    accept: 'images',
    file  : $scope.preview,
    height: 275,
    // hidePreview: true,
    size  : 500000,
    type  : 'advertisement',
    width : '100%'
  };

  $scope.save = function () {
    workshopAPI.post('/system_settings/update', {
      hide_dashboard_ad: !$scope.display_advertisement
    }, 'system_settings')
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISEMENT_SETTINGS_UPDATED'), 'success');

      $scope.form.file.$pristine ? $scope.form.$setPristine() : $scope.form.display_advertisement.$pristine = true;

      sessionObjAPI.refresh();
    })
    .catch(err => {
      messages.error(err);
    });
  };
}